import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import { alpha, Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import { REGISTRATION_FIELD_FILL_BG } from '../registrationFormFieldStyles';
import { ErrorWithIcon } from '@ui/components/common/TextField/ErrorWithIcon';
import InfoIconTooltip from '@ui/components/common/Tooltips/InfoIconTooltip';
const EButtonGroupField = ({ name, control, label, children, options, rules, error, tooltipText, bgColor = REGISTRATION_FIELD_FILL_BG, notSelectedBgColor = 'transparent', disabled = false, onChange: onChangeProp, defaultValue: defaultValueProp, ...rest }) => {
    const theme = useTheme();
    const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const optionCount = options.length;
    const gridTemplateColumns = useMemo(() => ({
        xs: `repeat(${Math.max(1, Math.min(optionCount, 2))}, minmax(0, 1fr))`,
        md: `repeat(${Math.max(1, Math.min(optionCount, 3))}, minmax(0, 1fr))`
    }), [optionCount]);
    const selectedBg = alpha(theme.palette.primary.main, 0.24);
    const selectedColor = theme.palette.text.primary;
    const borderColor = theme.palette.common.grey.dark;
    const styledLabel = useMemo(() => !label ? undefined : (_jsxs(Box, { display: 'inline-flex', alignItems: 'center', gap: '4px', sx: { pointerEvents: 'auto' }, children: [_jsx(Typography, { variant: 'body2', color: disabled ? 'text.disabled' : 'text.primary', children: label }), tooltipText && (_jsx(Box, { sx: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    pointerEvents: 'auto',
                    cursor: 'pointer'
                }, children: _jsx(InfoIconTooltip, { title: tooltipText, size: 'small', variant: 'dark' }) }))] })), [label, tooltipText, disabled]);
    return (_jsx(Controller, { name: name, control: control, rules: rules, defaultValue: defaultValueProp !== undefined ? defaultValueProp : options[0]?.value, render: ({ field }) => (_jsxs(Box, { width: '100%', children: [_jsxs(Box, { sx: {
                        width: '100%',
                        background: bgColor,
                        borderRadius: '12px',
                        p: 2,
                        gap: '12px',
                        display: 'flex',
                        flexDirection: 'column'
                    }, children: [styledLabel, _jsx(Box, { sx: {
                                display: 'grid',
                                gridTemplateColumns,
                                gap: 1,
                                width: '100%'
                            }, children: options.map((tab) => {
                                const isSelected = field.value === tab.value;
                                return (_jsx(Button, { variant: 'outlined', fullWidth: true, disabled: disabled, sx: {
                                        fontSize: isMobileScreen ? '11px' : '',
                                        minHeight: 45,
                                        borderRadius: '14px',
                                        textTransform: 'none',
                                        width: '100%',
                                        minWidth: 0,
                                        maxWidth: '100%',
                                        backgroundColor: isSelected ? selectedBg : notSelectedBgColor,
                                        color: isSelected ? selectedColor : borderColor,
                                        border: `1px solid ${isSelected ? borderColor : alpha(theme.palette.grey[500], 0.32)}`,
                                        fontWeight: 500,
                                        '&:hover': {
                                            backgroundColor: isSelected ? selectedBg : notSelectedBgColor,
                                            color: isSelected ? selectedColor : borderColor,
                                            borderColor: isSelected ? borderColor : alpha(theme.palette.grey[500], 0.32)
                                        }
                                    }, size: isMobileScreen ? 'small' : 'medium', onClick: () => {
                                        if (disabled)
                                            return;
                                        field.onChange(tab.value);
                                        if (onChangeProp)
                                            onChangeProp(tab.value);
                                    }, disableRipple: true, children: tab.label }, tab.value));
                            }) }), children] }), _jsx(ErrorWithIcon, { error: error, mt: 0.5, ml: 0.5 })] })) }));
};
export default EButtonGroupField;
